function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
import { DynamicDestinations } from './destinations-dynamicitems';
export var DestinationDetailListController =
/*#__PURE__*/
function () {
  _createClass(DestinationDetailListController, null, [{
    key: "$inject",
    get: function get() {
      return ['$scope', '$state', '$stateParams', '$timeout', 'DestinationResourceFactory'];
    }
  }]);

  function DestinationDetailListController($scope, $state, $stateParams, $timeout, DestinationResourceFactory) {
    var _this = this;

    _classCallCheck(this, DestinationDetailListController);

    /* BINDABLE : INJECTS */
    Object.assign(this, {
      $scope: $scope,
      $state: $state,
      $stateParams: $stateParams,
      $timeout: $timeout,
      DestinationResourceFactory: DestinationResourceFactory
    });
    /* BINDABLE : DATA */

    this.currentId = null;
    this.SearchParams = {};
    /* EVENTS */
    //Register any event listeners

    $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      // Wait for the current digest cycle to finish, so the grid will display properly
      _this.$timeout(function () {
        // Utilize parameters
        _this.SearchParams = toParams;
        _this.currentId = toParams.id;
      });
    });
  }
  /* IMPLEMENTATION : BINDABLE */


  _createClass(DestinationDetailListController, [{
    key: "openDetail",
    value: function openDetail(destinationId) {
      this.$state.go('destinationDetails', {
        id: destinationId
      });
    }
  }, {
    key: "backToSearch",
    value: function backToSearch() {
      this.$state.go('settingDestinations', {}, {
        notify: true
      });
    }
    /* IMPLEMENTATION : PRIVATE */
    // All private methods should start with '_' in order to distinguish them

    /* INITIALIZATION */

  }, {
    key: "$onInit",
    value: function $onInit() {
      this.dynamicItems = new DynamicDestinations(this.$stateParams, this.$timeout, this.DestinationResourceFactory);
    }
  }]);

  return DestinationDetailListController;
}();